import yup from 'src/libs/yup';

const RoleFilterSchema = yup.object().shape({
  name: yup.string().label('Nome'),
  group: yup.string().label('Grupo'),
  status: yup.array().of(yup.string()).nullable().label('Status'),
});

export default RoleFilterSchema;
